import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState = false;

export const MANUAL_ADJUSTMENTS_FAULT = "Manual Adjustments";
export const EVENT_CHANGE_FAULT = "Event Change";

export const ADJUSTMENT_FAULT_TYPES: Array<string> = [
	MANUAL_ADJUSTMENTS_FAULT,
	"AFB Error",
	"Consignor Error",
	"Consignor Liability",
	"SFC Error",
	EVENT_CHANGE_FAULT,
];

export interface ICreateAdjustmentParams {
	InvoiceID: number | null;
	adjustmentAmount: number;
	adjustmentDate: string;
	adjustmentType: string;
	companyName: string;
	notes: string;
	organizationId: number | null;
	organizationSubcategoryId: number | null;
}

export const { thunk: createAdjustment, slice: createAdjustmentSlice } = getThunkAndSlice<
	ICreateAdjustmentParams,
	typeof initialState
>({
	initialState,
	path: "/api/Sales/CreateAdjustment",
	method: "post",
});
